import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Button from "@components/buttons/Button/Button";
import GuestBookDocument, { GuestBookDocumentProps } from "./GuestBookDocument";

interface GuestBookPDFDownloadButtonProps extends GuestBookDocumentProps {
    overrideName?: string;
}

export const GuestBookPDFDownloadButton: React.FC<GuestBookPDFDownloadButtonProps> = ({
    guestBook,
    orientation,
    pageSize,
    overrideName,
}) => {
    const defaultFileName = `${guestBook.firstName}_${guestBook.lastName}_GuestBook_${pageSize}.pdf`;
    const fileName = overrideName ? `${overrideName}_${pageSize}.pdf` : defaultFileName;

    return (
        <PDFDownloadLink
            document={(
                <GuestBookDocument
                    guestBook={guestBook}
                    orientation={orientation}
                    pageSize={pageSize}
                />
            )}
            fileName={fileName}
        >
            <Button variant="primary" size="medium" onClick={() => {}}>
                Download
            </Button>
        </PDFDownloadLink>
    );
};

export default GuestBookPDFDownloadButton;
